import { useState, useEffect, useCallback } from "react";
import { Menu, X } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import {
  mobileNavContainerVariant,
  mobileNavListVariant,
  mobileNavExitProps,
} from "../data/animationConfig";

const navLinkBaseClasses =
  "font-light tracking-widest text-xs uppercase text-gray-800";

const activeStyleCallBack = ({ isActive }) =>
  `${
    isActive ? "selected navlink text-teal-600" : "navlink text-gray-800"
  } ${navLinkBaseClasses}`;

const NavLinks = () => {
  return (
    <>
      <NavLink to="/" className={activeStyleCallBack}>
        Home
      </NavLink>
      <NavLink to="/lifestyle-portfolio" className={activeStyleCallBack}>
        Lifestyle
      </NavLink>
      <NavLink to="/maternity-portfolio" className={activeStyleCallBack}>
        Maternity & Newborn
      </NavLink>
      <NavLink to="/wedding-portfolio" className={activeStyleCallBack}>
        Weddings
      </NavLink>
      <NavLink to="/about" className={activeStyleCallBack}>
        About
      </NavLink>
      <NavLink to="/book-now">
        <button
          className={`bg-gradient-to-r from-teal-500 to-teal-600 text-white hover:from-teal-600 hover:to-teal-700 rounded-md font-medium mx-5  px-6 py-2 ${navLinkBaseClasses} `}
        >
          Book Now
        </button>
      </NavLink>
    </>
  );
};

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleNavbar = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* Wrapper div */}
      <nav className="flex flex-[1] items-center justify-end overflow-hidden text-white ">
        <div className="hidden justify-end md:flex">
          <NavLinks />
        </div>
        <div className="w-[75px] flex justify-end md:hidden">
          <button
            onClick={toggleNavbar}
            className=" z-50 relative p-2 hover:bg-gray-700/20 rounded-md transition-colors"
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? (
              <X size={24} color="#fff" className="relative z-50" />
            ) : (
              <Menu size={24} color="#1f2937" />
            )}
          </button>
        </div>
      </nav>
      {/* Mobile Menu */}
      <AnimatePresence mode="wait">
        {isOpen && (
          <motion.div
            layout="position"
            key="nav-links"
            variants={mobileNavContainerVariant}
            initial="hidden"
            animate="show"
            exit="exit"
            className="w-full flex flex-col items-center text-center space-y-4 md:hidden py-6"
          >
            <motion.div
              variants={mobileNavListVariant}
              {...mobileNavExitProps}
              className="w-full"
            >
              <NavLink to="/" className={activeStyleCallBack} text-sm>
                Home
              </NavLink>
            </motion.div>
            <motion.div
              variants={mobileNavListVariant}
              {...mobileNavExitProps}
              className="w-full"
            >
              <NavLink to="/about" className={activeStyleCallBack} text-sm>
                About Us
              </NavLink>
            </motion.div>
            <motion.div
              variants={mobileNavListVariant}
              {...mobileNavExitProps}
              className="w-full"
            >
              <NavLink to="/lifestyle-portfolio" className={activeStyleCallBack} text-sm>
                Lifestyle portraits
              </NavLink>
            </motion.div>
            <motion.div
              variants={mobileNavListVariant}
              {...mobileNavExitProps}
              className="w-full"
            >
              <NavLink to="/maternity-portfolio" className={activeStyleCallBack} text-sm>
                Maternity & Newborn
              </NavLink>
            </motion.div>
            <motion.div
              variants={mobileNavListVariant}
              {...mobileNavExitProps}
              className="w-full"
            >
              <NavLink to="/wedding-portfolio" className={activeStyleCallBack} text-sm>
                Weddings
              </NavLink>
            </motion.div>
            <motion.div
              variants={mobileNavListVariant}
              {...mobileNavExitProps}
              className="w-full"
            >
              <NavLink to="/portfolio" className={activeStyleCallBack} text-sm>
                Portfolio
              </NavLink>
            </motion.div>
            <motion.div
              variants={mobileNavListVariant}
              {...mobileNavExitProps}
              className="w-full"
            >
              <NavLink to="/book-now">
                <div className="flex justify-center items-center">
                  <button
                    className={`bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-md font-medium mx-auto my-2 px-6 py-3`}
                  >
                    Book Now
                  </button>
                </div>
              </NavLink>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Nav;
